/*
 *
 * ChooseSuppliersModal
 *
 * @version 1.0.0
 * @author GitHub Copilot
 * @since 04-Sep-2025
*/

import ChooseSuppliersModal from './ChooseSuppliersModalContainer'

export default ChooseSuppliersModal
